export type Effect = 'appear' | 'fade_in';

export default class IllustrationRenderOptions {
  constructor(public effect?: Effect) {}
}
